import { useCallback } from 'react'
import { useResolvedPath } from 'react-router-dom'
import { useAuthenticationContext } from '../auth/AuthenticationContextProvider'
import { isPathAuthorized } from '../auth/routeAuth'

/**
 * Returns a function that checks whether the current user is authorized
 * to access a given route path, based on the route's `auth` handle metadata.
 *
 * Absolute paths (starting with "/") are matched directly against the route tree.
 * Relative paths are resolved from the current route's location.
 */
export function useCanNavigateTo(): (path: string) => boolean {
  const authContext = useAuthenticationContext()
  const basePath = useResolvedPath('.').pathname

  return useCallback(
    (path: string): boolean => {
      const absolutePath = path.startsWith('/') ? path : `${basePath}/${path}`
      return isPathAuthorized(absolutePath, authContext)
    },
    [authContext, basePath]
  )
}
